// UI strings for the two supported interface languages.
// Scenario content (names, titles, stage names) comes from the backend and is not translated here.

export const LANGUAGES = {
  'zh-TW': { label: '繁體中文', speech: 'zh-TW' },
  'en': { label: 'English', speech: 'en-US' },
};

export const DEFAULT_LANGUAGE = 'zh-TW';

const translations = {
  'zh-TW': {
    nav: {
      scenarios: '陪練課程',
      practice: '實戰演練',
      englishPractice: '英文口說',
      history: '練習紀錄',
      settings: '設定',
      ocr: '圖片轉流程圖',
      evaluations: '評估結果列表',
      feedback: '用戶回饋列表',
      login: '登入',
      logout: '登出',
      guest: '訪客',
    },
    category: {
      '銀行理專': '銀行理專',
      '銀行電銷': '銀行電銷',
    },
    settings: {
      title: '設定',
      language: '介面語言',
      languageHint: 'AI 客戶的回覆與語音辨識也會使用這個語言。',
      name: '名字',
      namePlaceholder: '請輸入名字',
      gender: '性別',
      male: '男性',
      female: '女性',
      avatarStyle: '頭像樣式',
      randomize: '隨機生成',
      avatarBg: '頭像背景色',
      colors: {
        b6e3f4: '藍色', ffdfbf: '橘色', ffd1dc: '粉色', c1f0c1: '綠色',
        d4e7ff: '淺藍', ffe5d9: '淺橘', f0e6ff: '淺紫', fff4e6: '米色',
      },
      save: '儲存設定',
      saved: '已儲存設定',
    },
  },
  'en': {
    nav: {
      scenarios: 'Training Courses',
      practice: 'Live Practice',
      englishPractice: 'English Speaking',
      history: 'Practice History',
      settings: 'Settings',
      ocr: 'Image to Flowchart',
      evaluations: 'Evaluation Results',
      feedback: 'User Feedback',
      login: 'Log in',
      logout: 'Log out',
      guest: 'Guest',
    },
    category: {
      '銀行理專': 'Wealth Advisor',
      '銀行電銷': 'Telesales',
    },
    settings: {
      title: 'Settings',
      language: 'Interface Language',
      languageHint: 'The AI customer replies and speech recognition will use this language too.',
      name: 'Name',
      namePlaceholder: 'Enter your name',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      avatarStyle: 'Avatar Style',
      randomize: 'Randomize',
      avatarBg: 'Avatar Background',
      colors: {
        b6e3f4: 'Blue', ffdfbf: 'Orange', ffd1dc: 'Pink', c1f0c1: 'Green',
        d4e7ff: 'Light Blue', ffe5d9: 'Light Orange', f0e6ff: 'Light Purple', fff4e6: 'Beige',
      },
      save: 'Save Settings',
      saved: 'Settings saved',
    },
  },
};

export default translations;
